var desvg = require('.')
var React = require('react')

module.exports = desvg.bind(null, React.createElement.bind(React))



//////////////////
// WEBPACK FOOTER
// ./~/@kossnocorp/desvg/react.js
// module id = 65
// module chunks = 0